import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader.js";

export async function print(params) {
  const axios = axiosInstanceWithoutLoader().primoLab;
  let data = [];
  await axios
    .post(`/devices/print`, params)
    .then(async (resp) => {
      data = resp.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { data };
}
